/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectTagsResponse } from '../../models/project-tags-response';
import { PutProjectTagsRequest } from '../../models/put-project-tags-request';

export interface ProjectsControllerPutTags$Params {

/**
 * Project id.
 */
  id: string;
      body: PutProjectTagsRequest
}

export function projectsControllerPutTags(http: HttpClient, rootUrl: string, params: ProjectsControllerPutTags$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectTagsResponse>> {
  const rb = new RequestBuilder(rootUrl, projectsControllerPutTags.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectTagsResponse>;
    })
  );
}

projectsControllerPutTags.PATH = '/planning-projects/v1-develop/projects/{id}/tags';
